// @services/ReportedReview/GetAcceptedReviewsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'
import { ReportedReview } from './GetReportedReviewsService'

export class AcceptedReviewsService {
  async getAcceptedReviews(): Promise<ReportedReview[]> {
    const api = new ScrubstrApiQueryService()

    // call the API - axios already parses JSON, so response is the array directly
    const data = await api.get<ReportedReview[]>({
      endpoint: 'admin/reviews/accepted-reviews',
    })

    // Ensure we return an array
    return Array.isArray(data) ? data : []
  }
}
